import React from 'react';

function PrivateKeyTutorial() {
  return (
    <div className="tutorial-section" style={{
      background: '#f8f9fa',
      border: '1px solid #dee2e6',
      borderRadius: '8px',
      padding: '20px',
      margin: '20px 0'
    }}>
      <h3 style={{ color: '#495057', marginBottom: '15px' }}>🔑 配置刷分私钥</h3>
      
      <div className="tutorial-steps">
        <div className="tutorial-step" style={{ marginBottom: '20px' }}>
          <h4 style={{ color: '#007bff', marginBottom: '10px' }}>步骤1: 填入刷分私钥</h4>
          <p style={{ color: '#6c757d', fontSize: '16px' }}>
            你需要一个bsc账号来支付gas, 每次卖出大概会消耗你0.02u左右的gas, 所以你需要填一个私钥在这里
            里面放一丁点的bnb来支付卖出所用的gas, 不要放太多了, 放一点点没人会偷走里面的gas.
          </p>
          <div style={{ textAlign: 'center', marginBottom: '10px' }}>
            <img 
              src="/images/enter-private-key.png"
              alt="填入私钥"
              style={{ 
                maxWidth: '100%', 
                height: 'auto',
                border: '1px solid #ddd',
                borderRadius: '5px'
              }}
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'block';
              }}
            />
            <div style={{ 
              display: 'none', 
              padding: '40px', 
              backgroundColor: '#f8f9fa', 
              border: '2px dashed #dee2e6',
              borderRadius: '5px',
              color: '#6c757d',
              textAlign: 'center'
            }}>
              📱 填入私钥界面图片
            </div>
          </div>
        </div>
        
        <div className="tutorial-note" style={{
          backgroundColor: '#e2f3ff',
          padding: '15px',
          borderRadius: '5px',
          marginTop: '20px'
        }}>
          <h4 style={{ color: '#0069d9', marginBottom: '10px' }}>注意事项:</h4>
          <p style={{ color: '#495057', fontSize: '14px' }}>
            密钥填入后系统会记住，第二次使用时不需要重新填入。
          </p>
          <p style={{ color: '#495057', fontSize: '14px', fontWeight: 'bold' }}>
            私钥信息非常重要，请确保从安全渠道获取，并且不要泄露给他人！
          </p>
        </div>
      </div>
    </div>
  );
}

export default PrivateKeyTutorial; 